import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type UneditedOrdersTabProps = {
    label: string;
};

const UneditedOrdersRoute = '/unedited-orders';

let routes = [UneditedOrdersRoute];

function UneditedOrdersTab({ label, ...props }: UneditedOrdersTabProps) {
    function handleClick() {
        history.push(UneditedOrdersRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={UneditedOrdersRoute} />;
}

function TranslatedUneditedOrdersTab(props) {
    const label = Translate('header/nav/unedited-orders');
    return <UneditedOrdersTab {...props} label={label} />;
}

TranslatedUneditedOrdersTab.routes = routes;

export default TranslatedUneditedOrdersTab;
